import { Box, Button, Stack } from '@mui/material'
import { FC } from 'react'
import EngagementReviewTimeIcon from '../../../../assets/images/icons/engagement-review-time-icon.svg?react'
import { REPLAYER_SPEED_OPTIONS } from '../constants'

interface SpeedControlsProps {
  currentSpeed: number
  onSpeedChange: (speed: number) => void
}

export const SpeedControls: FC<SpeedControlsProps> = ({ currentSpeed, onSpeedChange }) => {
  return (
    <Stack direction={'row'} alignItems="center" spacing={'var(--spacing-s)'}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <EngagementReviewTimeIcon />
      </Box>
      {REPLAYER_SPEED_OPTIONS.map(speedOption => (
        <Button
          key={speedOption}
          variant={'text'}
          size="small"
          onClick={() => onSpeedChange(speedOption)}
          sx={{
            minWidth: 'auto',
            fontSize: 'var(--size-s)',
            fontWeight: currentSpeed === speedOption ? '700' : '400',
            padding: 0,
            color: currentSpeed === speedOption ? 'var(--yellow-500)' : 'var(--text-secondary)',
            '&:hover': {
              bgcolor: 'transparent'
            }
          }}
          data-testid={`ert-player-controls-speed-${speedOption}x`}
        >
          {speedOption}x
        </Button>
      ))}
    </Stack>
  )
}
